import React from 'react'
import styled from 'styled-components'

const ModalWrapper = styled.div`
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999999;
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: ${props => props.light ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0,0,0,0.8)'};
  background-size: 100vw 100vh;
  overflow: visible;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: ${props => props.top ? 'start' : 'center'};
`
class Modal extends React.Component {
  componentWillReceiveProps(nextProps) {
    document.body.style.overflow = nextProps.isModalOpen ? 'hidden' : 'scroll'
  }
  render() {
    const { light, isModalOpen, children, top } = this.props
    if (!isModalOpen) {
      return null
    }
    return (
      <ModalWrapper top={top} light={light} duration={.3}>
        {children}
      </ModalWrapper>
    )
  }
}

export default Modal
